import React from "react";
import { AiOutlinePlus, AiOutlineRight } from "react-icons/ai";
import { Button } from "@mui/material";

const Faqs = () => {
  const yuvasarthi = [
    {
      id: 1,
      list: "Gain hands-on experience by working on real-world projects that mirror industry challenges.",
    },
    {
      id: 2,
      list: "Get real time industry experience.",
    },
    {
      id: 3,
      list: "Embrace a dynamic environment that encourages innovative thinking, idea generation, and overcoming project challenges.",
    },
    {
      id: 4,
      list: "Acquire essential professional skills such as communication, teamwork, problem-solving, and time management for a strong and smooth career start.",
    },
    {
      id: 5,
      list: "Internship at The Innovative Solutions is a great learning experience.",
    },
  ];

  const forwhom = [
    {
      id: 1,
      list: "Knowledge of Visual studio, Subline code, Xampp.",
    },
    {
      id: 2,
      list: "Proficient understanding of web markup languages such as HTML5 and CSS3.",
    },
    {
      id: 3,
      list: "Excellent problem-solving skills and attention to detail.",
    },
    {
      id: 4,
      list: "Strong communication and collaboration skills to work effectively within a team.",
    },
    {
      id: 5,
      list: "Excellent time management Skills",
    },
  ];

  const moto = [
    {
      id: 1,
      list: "Knowledge of Eclipse, Android Studio, AVD Manager, Android SDK.",
    },
    {
      id: 2,
      list: "Solid understanding of databases and SQL.",
    },
    {
      id: 3,
      list: "Strong problem-solving and analytical skills to identify and resolve application issues.",
    },
  ];

  return (
    <>
      <div className="container mt-3">
        <h2>Frequently Ask Questions</h2>
        {/* 
        <p className="fs-5">
          Are you a passionate and ambitious IT professional looking for a
          valuable learning experience? Look no further! The Innovative
          Solutions offers exciting internship opportunities designed to provide
          you with hands-on experience and mentorship, ensuring you're always on
          the right path to success.
        </p> */}

        <div className="accordion" id="accordionPanelsStayOpenExample">
          <div className="accordion-item border border-1 border-info rounded-3 mb-3">
            <h2 className="accordion-header" id="panelsStayOpen-headingOne">
              <button
                className="accordion-button "
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#panelsStayOpen-collapseOne"
                aria-expanded="true"
                aria-controls="panelsStayOpen-collapseOne"
              >
                <AiOutlinePlus className="fs-5" /> &nbsp; What is Yuvasarthi?
              </button>
            </h2>
            <div
              id="panelsStayOpen-collapseOne"
              className="accordion-collapse collapse show"
              aria-labelledby="panelsStayOpen-headingOne"
            >
              <div className="accordion-body">
                {yuvasarthi.map((item) => {
                  return (
                    <>
                      <p>
                        <AiOutlineRight className="fs-5" /> Lorem ipsum dolor
                        sit amet consectetur adipisicing elit. Odit ea odio, ex
                        beatae magnam optio! Culpa hic quis labore blanditiis!
                      </p>
                    </>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="accordion-item border border-1 border-info rounded-3 mb-3">
            <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#panelsStayOpen-collapseTwo"
                aria-expanded="false"
                aria-controls="panelsStayOpen-collapseTwo"
              >
                <AiOutlinePlus className="fs-5" /> &nbsp; For Whom Yuvasarthi
                Works?
              </button>
            </h2>
            <div
              id="panelsStayOpen-collapseTwo"
              className="accordion-collapse collapse"
              aria-labelledby="panelsStayOpen-headingTwo"
            >
              <div className="accordion-body">
                <h4>Job Description :</h4>
                {forwhom.map((item) => {
                  return (
                    <>
                      <p>
                        <AiOutlineRight className="fs-5" /> {item.list}
                      </p>
                    </>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="accordion-item border border-1 border-info rounded-3 mb-3">
            <h2 className="accordion-header" id="panelsStayOpen-headingThree">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#panelsStayOpen-collapseThree"
                aria-expanded="false"
                aria-controls="panelsStayOpen-collapseThree"
              >
                <AiOutlinePlus className="fs-5" /> &nbsp; Main Moto Of
                Yuvasarthi.
              </button>
            </h2>
            <div
              id="panelsStayOpen-collapseThree"
              className="accordion-collapse collapse"
              aria-labelledby="panelsStayOpen-headingThree"
            >
              <div className="accordion-body">
                <h4>Job Description :</h4>
                {moto.map((item) => {
                  return (
                    <>
                      <p>
                        <AiOutlineRight className="fs-5" /> {item.list}
                      </p>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        {/* 
        <Button variant="contained" className="mb-3">
          <a
            href="https://forms.gle/WB82s4fU6WzUqgTn6"
            target="_blank"
            rel="noreferrer"
            className="text-decoration-none text-white"
          >
            Apply Now
          </a>
        </Button> */}
      </div>
    </>
  );
};

export default Faqs;
